function formatCurrency(value: string): string {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '')

  // Pad with zeros if needed
  const padded = digits.padStart(3, '0')

  // Separate cents
  const integerPart = padded.slice(0, -2)
  const decimalPart = padded.slice(-2)

  // Only add thousand separator if integer part has more than 3 digits
  let integerWithSeparator: string
  if (integerPart.length > 3) {
    integerWithSeparator = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } else {
    integerWithSeparator = integerPart
  }

  // Remove leading zeros except when value is zero
  integerWithSeparator = integerWithSeparator.replace(/^0+(?!$)/, '')

  return `${integerWithSeparator},${decimalPart}`
}

function setCursorToEnd(el: HTMLInputElement) {
  // Set cursor to the end of the input
  setTimeout(() => {
    el.selectionStart = el.selectionEnd = el.value.length
  })
}

const currencyMask = {
  mounted(el: HTMLInputElement) {
    function onInput(e: Event) {
      const input = e.target as HTMLInputElement
      const digits = input.value.replace(/\D/g, '')
      input.value = formatCurrency(digits)
      setCursorToEnd(input)
      // Emit input event for v-model compatibility
      input.dispatchEvent(new Event('input'))
    }

    function onKeyDown(e: KeyboardEvent) {
      // Allow only digits, backspace, delete, tab, arrows, home, end
      if (
        !(
          (e.key >= '0' && e.key <= '9') ||
          ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)
        )
      ) {
        e.preventDefault()
      }
    }

    el.value = '0,00'
    el.addEventListener('input', onInput)
    el.addEventListener('keydown', onKeyDown)

    // Store handlers for cleanup
    ;(el as any).__currencyMaskHandlers = { onInput, onKeyDown }
  },
  beforeUnmount(el: HTMLInputElement) {
    const handlers = (el as any).__currencyMaskHandlers
    if (handlers) {
      el.removeEventListener('input', handlers.onInput)
      el.removeEventListener('keydown', handlers.onKeyDown)
      delete (el as any).__currencyMaskHandlers
    }
  },
}

export default currencyMask
